import { EAuthTypes, EPlatformName } from "../types";
// import BaseDatabase from "../components/blocks/telematics/connectors/BaseDatabase.vue";
import BaseToken from "../components/blocks/telematics/connectors/BaseToken.vue";
import BaseOauth from "../components/blocks/telematics/connectors/BaseOauth.vue";
import BaseBasic from "../components/blocks/telematics/connectors/BaseBasic.vue";
import TrimbleBasic from "../components/blocks/telematics/connectors/TrimbleBasic.vue";
import WebfleetBasic from "../components/blocks/telematics/connectors/WebfleetBasic.vue";
import BaseAccountName from "../components/blocks/telematics/connectors/BaseAccountName.vue";
import BaseAccountNameWOInstructionsConfirmation from "../components/blocks/telematics/connectors/BaseAccountNameWOInstructionsConfirmation.vue";
import BaseUsernameToken from "../components/blocks/telematics/connectors/BaseUsernameToken.vue";
import SwitchboardToken from "../components/blocks/telematics/connectors/SwitchboardToken.vue";
import BaseUserPassword from "../components/blocks/telematics/connectors/BaseUserPassword.vue";
import BaseEmail from "../components/blocks/telematics/connectors/BaseEmail.vue";
import VerizonAccountName from "../components/blocks/telematics/connectors/VerizonAccountName.vue";
import WaylensBasic from "../components/blocks/telematics/connectors/WaylensBasic.vue";
import SurfsightAccountName from "../components/blocks/telematics/connectors/SurfsightAccountName.vue";
import { Component } from "vue";
import RequestTsp from "../components/blocks/telematics/connectors/RequestTsp.vue";
import GeotabBasic from "@/modules/onboarding/components/blocks/telematics/connectors/GeotabBasic.vue";
import NetradyneBasic from "@/modules/onboarding/components/blocks/telematics/connectors/NetradyneBasic.vue";
import BaseDotNumber from "../components/blocks/telematics/connectors/BaseDotNumber.vue";
import GorillaSafetyBasic from "../components/blocks/telematics/connectors/GorillaSafetyBasic.vue";

export const platformMethodForm: Partial<
  Record<`${EPlatformName}-${EAuthTypes}`, Component>
> = {
  /* GEOTAB resellers start */
  // [`${EPlatformName.GEOTAB}-${EAuthTypes.BASIC}`]: BaseDatabase, // deprecated in favor of GeotabBasic 15 May 2025
  [`${EPlatformName.GEOTAB}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.ACTSOFT_ENCORE}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.ADVANTAGE_ASSET_TRACKING}-${EAuthTypes.BASIC}`]:
    GeotabBasic,
  [`${EPlatformName.ARGOS_CONNECTED_SOLUTIONS}-${EAuthTypes.BASIC}`]:
    GeotabBasic,
  [`${EPlatformName.ARI_FLEET}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.ASSURED_TELEMATICS}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.ATNT_FLEET}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.ATTRIX}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.BADGER_FLEET_SOLUTIONS}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.BAR_CODING_CANADA}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.BLUEARROW}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.CARRIERHQ}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.ENVUE_TELEMATICS}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.FLEET_NAV_SYSTEMS}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.FLEET_PROFIT_CENTER}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.FLEETBOSS_GPS}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.FLEETHOSTER}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.FLEETISTICS}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.FLEETLOCATE_GEOTAB}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.FLEETMASTER}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.FLEXPORT}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.GEOFORCE}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.GLOSTONE}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.GOFLEET}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.GOGPS}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.GPS_FLEET_FINDER}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.GPS_SOLUTIONS}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.GPS_TRACKING_CANADA}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.GRAYBOX_SOLUTIONS}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.GRIDLINE}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.HIGHPOINT_GPS}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.IOTAB}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.LYNX}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.ONTRAK_SOLUTIONS}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.PENSKE}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.PREPASS_ELD}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.QUALITY_GPS}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.RMJ_TECHNOLOGIES}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.RUSH_ENTERPRISES}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.RYDER}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.SAFETY_VISION}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.SHELL_TELEMATICS}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.SURECAM}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.T_MOBILE}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.TRANSFLO}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.TRAXXISGPS}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.VERTRAX}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.ZENDUIT}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.ADVANTAGE_ONE}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.EAGLE_WIRELESS}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.HOLMAN}-${EAuthTypes.BASIC}`]: GeotabBasic,
  [`${EPlatformName.ENTERPRISE_FLEET_MANAGEMENT}-${EAuthTypes.BASIC}`]:
    GeotabBasic,
  [`${EPlatformName.DICAN}-${EAuthTypes.BASIC}`]: GeotabBasic,
  /* GEOTAB resellers end */
  [`${EPlatformName.SAMSARA}-${EAuthTypes.OAUTH2}`]: BaseOauth,
  [`${EPlatformName.SAMSARA}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.SAMSARA}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.MOTIVE}-${EAuthTypes.OAUTH2}`]: BaseOauth,
  [`${EPlatformName.MOTIVE}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.MOTIVE}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.TRIMBLE}-${EAuthTypes.BASIC}`]: TrimbleBasic,
  [`${EPlatformName.WAYLENS}-${EAuthTypes.BASIC}`]: WaylensBasic,
  [`${EPlatformName.WEBFLEET}-${EAuthTypes.ACCOUNT}`]: BaseAccountName,
  [`${EPlatformName.WEBFLEET}-${EAuthTypes.BASIC}`]: WebfleetBasic,
  [`${EPlatformName.VERIZON}-${EAuthTypes.ACCOUNT}`]: VerizonAccountName,
  [`${EPlatformName.VERIZON}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.SURFSIGHT}-${EAuthTypes.BASIC}`]: SurfsightAccountName,
  // TODO: for 2024 integration C0
  // [`${EPlatformName.GPS_INSIGHT}-${EAuthTypes.ACCOUNT}`]: BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.GPS_INSIGHT}-${EAuthTypes.TOKEN}`]: BaseUsernameToken,
  [`${EPlatformName.ELITEGPS}-${EAuthTypes.TOKEN}`]: BaseUsernameToken,
  [`${EPlatformName.WEX_TELEMATICS}-${EAuthTypes.TOKEN}`]: BaseUsernameToken,
  [`${EPlatformName.INSIGHT_MOBILE_DATA}-${EAuthTypes.TOKEN}`]:
    BaseUsernameToken,
  [`${EPlatformName.MONARCH_GPS}-${EAuthTypes.TOKEN}`]: BaseUsernameToken,
  [`${EPlatformName.RHINO}-${EAuthTypes.TOKEN}`]: BaseUsernameToken,
  [`${EPlatformName.TOUCHTEL_GPS}-${EAuthTypes.TOKEN}`]: BaseUsernameToken,
  [`${EPlatformName.TRUCKSPY}-${EAuthTypes.TOKEN}`]: BaseUsernameToken,
  [`${EPlatformName.WIALON}-${EAuthTypes.OAUTH2}`]: BaseOauth,
  [`${EPlatformName.WIALON}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.WIALON}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.GPS_COMMANDER}-${EAuthTypes.OAUTH2}`]: BaseOauth,
  [`${EPlatformName.GPS_COMMANDER}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.GPS_COMMANDER}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.MIX_TELEMATICS}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.EROAD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.EROAD}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.FLEET_COMPLETE}-${EAuthTypes.ACCOUNT}`]: BaseAccountName,
  [`${EPlatformName.FLEET_COMPLETE}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.TELUS}-${EAuthTypes.ACCOUNT}`]: BaseAccountName,
  [`${EPlatformName.TELUS}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.BIGROAD}-${EAuthTypes.ACCOUNT}`]: BaseAccountName,
  [`${EPlatformName.BIGROAD}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.ATNT_FLEET_COMPLETE}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountName,
  [`${EPlatformName.ATNT_FLEET_COMPLETE}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.FLEET_UP}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.FLEET_UP}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.LION_EIGHT}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.LION_EIGHT}-${EAuthTypes.TOKEN}`]: BaseToken,
  // [`${EPlatformName.LYTX}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.LYTX}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.LYTX}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.OMNITRACS}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.OMNITRACS}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.ISAAC}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.AZUGA}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.AZUGA_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.WORKWAVE}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.NETRADYNE}-${EAuthTypes.BASIC}`]: NetradyneBasic,
  [`${EPlatformName.NEXTRAQ}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.ONE_STEP_GPS}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.ONE_STEP_GPS}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.FLEETLOCATE_SPIREON_NSPIRE}-${EAuthTypes.BASIC}`]:
    BaseEmail,
  [`${EPlatformName.XRS}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.XRS}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.ZONAR}-${EAuthTypes.BASIC}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.ORBCOMM_ELD}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.ORBCOMM_BLUE_TREE}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.VISION_TRACK}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.GORILLA_SAFETY}-${EAuthTypes.ACCOUNT}`]: GorillaSafetyBasic,
  [`${EPlatformName.GORILLA_SAFETY}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.CLUTCH_ELD}-${EAuthTypes.ACCOUNT}`]: GorillaSafetyBasic,
  [`${EPlatformName.CLUTCH_ELD}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.CYNTRX_ELD_PLUS}-${EAuthTypes.ACCOUNT}`]:
    GorillaSafetyBasic,
  [`${EPlatformName.CYNTRX_ELD_PLUS}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.ELD_MANDATE_PRO}-${EAuthTypes.ACCOUNT}`]:
    GorillaSafetyBasic,
  [`${EPlatformName.ELD_MANDATE_PRO}-${EAuthTypes.BASIC}`]: BaseBasic,
  // [`${EPlatformName.FLEET_LOCATE_ELD}-${EAuthTypes.TOKEN}`]: BaseDotNumber,
  // [`${EPlatformName.FLEET_LOCATE_ELD}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.PATRIOT}-${EAuthTypes.ACCOUNT}`]: GorillaSafetyBasic,
  [`${EPlatformName.PATRIOT}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.SIMPLEX_ELD}-${EAuthTypes.ACCOUNT}`]: GorillaSafetyBasic,
  [`${EPlatformName.SIMPLEX_ELD}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.TRACK_ON_ELD}-${EAuthTypes.ACCOUNT}`]: GorillaSafetyBasic,
  [`${EPlatformName.TRACK_ON_ELD}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.TRUCKER_PATH_ELD_PRO}-${EAuthTypes.ACCOUNT}`]:
    GorillaSafetyBasic,
  [`${EPlatformName.TRUCKER_PATH_ELD_PRO}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.LINXUP}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.LINXUP}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.AWARE_GPS}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.AWARE_GPS}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.COMMAND_GPS}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.COMMAND_GPS}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.ELD_RIDER_PRO}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.ELD_RIDER_PRO}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.SHELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.SHELD}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.XELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.XELD}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.ZELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.ZELD}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.EVA_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.EVA_ELD}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.XPLORE_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.XPLORE_ELD}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.OPTIMA_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.OPTIMA_ELD}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.PRO_RIDE_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.PRO_RIDE_ELD}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.SPARKLE_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.SPARKLE_ELD}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.APEX_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.APEX_ELD}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.ROCK_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.ROCK_ELD}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.FLEETSHARP}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.FLEETSHARP}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.REQUEST}-${EAuthTypes.REQUEST}`]: RequestTsp,
  [`${EPlatformName.TELETRAC_NAVMAN}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.INTELLISHIFT}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.EZ_FLEET}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.SIMPLE_TRUCK_ELD}-${EAuthTypes.ACCOUNT}`]: BaseDotNumber,
  [`${EPlatformName.SIMPLE_E_LOG}-${EAuthTypes.ACCOUNT}`]: BaseDotNumber,
  [`${EPlatformName.GLOBAL_ELD}-${EAuthTypes.ACCOUNT}`]: BaseDotNumber,
  [`${EPlatformName.MICHELIN_CONNECTED_FLEET}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.MICHELIN_CONNECTED_FLEET}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.GPS_TRACKIT}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.GPS_TRACKIT}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.INTOUCH_GPS}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.INTOUCH_GPS}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.BRICKHOUSE_SECURITY}-${EAuthTypes.OAUTH2}`]: BaseOauth,
  [`${EPlatformName.BRICKHOUSE_SECURITY}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.BRICKHOUSE_SECURITY}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.TERMINUS_GPS_ELD}-${EAuthTypes.OAUTH2}`]: BaseOauth,
  [`${EPlatformName.TERMINUS_GPS_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.TERMINUS_GPS_ELD}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.BRANIX}-${EAuthTypes.OAUTH2}`]: BaseOauth,
  [`${EPlatformName.BRANIX}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.BRANIX}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.BLUE_INK}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.BLUE_INK}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.TX_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.TX_ELD}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.POP_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.POP_ELD}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.NEXTRAQ_MARCUS}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.NEXTRAQ_MARCUS}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.PEAK_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.PEAK_ELD}-${EAuthTypes.BASIC}`]: BaseBasic,
  // HOS Connect resellers
  [`${EPlatformName.HOS_247}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.BLACK_BEAR_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.COLUMBUS_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.STATE_ELOG}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.DY_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName._3PL_TEK}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.ABC_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.ACTION_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.ADVANTAGE_KNIGHTS_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.ALPHA_E_LOGBOOK}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.AMPM_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.BISON_ELOG}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.CAPTAIN_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.COBRA_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.DAILY_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.DFL_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.DIGITAL_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.DLOG_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.DYNAMIC_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.EGREEN_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.ELD_FOR_YOU}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.ELD2GO}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.ELD4TRUCKING}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.ELOG42}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.EXTREME_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.FLASH_ELOGS}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.GLOBCOM_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.HERO_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.INFINITY_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.IRONMAN_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.JUST_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.LEGACY_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.LOG_PLUS_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.MOONLIGHT_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.NOOR_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.NOVIO_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.ORIENT_STAR_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.PARAGON_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.PHOENIX_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.PIONEER_ELD_SOLUTION}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.POWERTRUCKS_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.PROJECT_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.QUICK_ELOGS_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.RENAISSANCE_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.ROBINHOOD_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.ROUTE_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.RUN_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.SBA_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.SF_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.SIMBA_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.SMART_CHOICE_LOGS}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.SPEEDLINE_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.STARWAY_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.SUPPORT_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.TEDDY_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.TEMPUS_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.TRUE_ROAD_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.TRUST_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.UNDER_CONTROL_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.UNITY_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.VLOG_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.XPERT_LOGS}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.YOULOG_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.ZAPHIRA_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.EBLUE_SUN_LOGS}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.ELD_DESIRED}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.FIRSTGATE_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.GRAND_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.ILOG_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.PLATINUM_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.READYSETPIPE_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.RED_FOX_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.REGULOG_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.SUBSET_LOGBOOK}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.UNIQUE_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.TOP_COMPLIANCE_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.OMEGA_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.RIDEHUB_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.TRACK_TRUCK}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.TRUCKSTAFF_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.DRAGON_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.FLEX_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.HIGHEST_GEARS}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.PDSYNC_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.TRUCK_FORD_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.ASAP_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.EXTENDED_ROAD_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.AUTOGRI_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.AVANGUARD_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.AXIOS_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.BELLFAM_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.BEST_SOURCE_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.BOLT_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.DOCUDRIVE_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.RING_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.EXPRESS_WAY_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.LOOKTRUCK_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.RS_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.VRH_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.LOGS_SKI_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.TURNSBUSS}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.PREMIERRIDE_LOGS}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.SIMPLEWAY_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.OZOD_EXPRESS_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.MAP_ELOG}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.AM_LOGS_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName._48_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.ROYAL_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.INSPIRE_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.SPLIT_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.ELD_ROAD_HOS}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.MATRACK}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.VESTIGE}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.GTS}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.VOYOMOTIVE}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.VOYOMOTIVE}-${EAuthTypes.BASIC}`]: BaseBasic,
  // GPSTAB resellers
  [`${EPlatformName.GPSTAB}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.GPSTAB}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.MAX_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.MAX_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.MOUNTAIN_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.MOUNTAIN_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.ELD_ONE}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.ELD_ONE}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.ROADSTAR_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.ROADSTAR_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.MASTER_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.MASTER_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.REAL_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.REAL_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.TFM_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.TFM_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.FM_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.FM_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.LIGHT_AND_TRAVEL_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.LIGHT_AND_TRAVEL_ELD}-${EAuthTypes.BASIC}`]:
    BaseUserPassword,
  [`${EPlatformName.ID_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.ID_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.NEO_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.NEO_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.COGO_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.COGO_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.DIALOG_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.DIALOG_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  // Trackensure resellers
  [`${EPlatformName.TRACKENSURE}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.TRACKENSURE}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.SWIFT_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.SWIFT_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.SWITCHBOARD}-${EAuthTypes.TOKEN}`]: SwitchboardToken,
  [`${EPlatformName.SWITCHBOARD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.AMBER_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.AMBER_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.CLUB_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.CLUB_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.ELD_PRO_SOLUTION}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.ELD_PRO_SOLUTION}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.PROTRACKING_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.PROTRACKING_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.SHARP_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.SHARP_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.VISTA_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.VISTA_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.ZENITH_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.ZENITH_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.ADA_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.ADA_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.ALFA_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.ALFA_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.ENSI_LOG}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.ENSI_LOG}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.INTERSTATE_FREEWAY}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.INTERSTATE_FREEWAY}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.SMART_ELOG}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.SMART_ELOG}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.SPRINT_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.SPRINT_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.TRIP_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.TRIP_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName._24HOS_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName._24HOS_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.FORTUNE_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.FORTUNE_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.ORION_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.ORION_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.PHANTOM_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.PHANTOM_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.TRENDY_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.TRENDY_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.VECTOR_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.VECTOR_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.WHEELS_ELOG}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.WHEELS_ELOG}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.FLEETHUNT}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.FLEETHUNT}-${EAuthTypes.BASIC}`]: BaseBasic,
  // Reliable ELD resellers
  [`${EPlatformName.RELIABLE_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.AT_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.MGK_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.NOOR_ELD_SOLUTION}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.ORIENT_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.AXION_ROUTE}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  // TT ELD resellers
  [`${EPlatformName.TT_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.TT_ELD}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.EVO_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.EVO_ELD}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.ONTIME_LOGS}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.ONTIME_LOGS}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.ZIPPY_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.ZIPPY_ELD}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.ONTIME_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.ONTIME_ELD}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.FIVE_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.FIVE_ELD}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.LOGFLEET_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.LOGFLEET_ELD}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.SUN_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.SUN_ELD}-${EAuthTypes.BASIC}`]: BaseBasic,
  [`${EPlatformName.FLEET_VISION}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.FLEET_VISION}-${EAuthTypes.BASIC}`]: BaseBasic,
  // Drive HOS resellers
  [`${EPlatformName.DRIVE_HOS}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.FACTOR_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.DAILY_ELD_PLUS}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.DSG_LOGS}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.DY_PLUS_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.EGREEN_ELD_PRO}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.UZBPRIME_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.ILOG_ELD_APP}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.LEADER_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.LUCID_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.PANDA_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.PRESTIGE_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.STARTRUCKS_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.US_FAST_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.US_POWER_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.VITALITY_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.ZEROMAX_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.BLUE_STAR_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.SECURE_PATH_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.FIRST_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.DRIVE_LENS_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.NIGHT_WATCH_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName._ELD88}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.AFS_WORLD_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.HUNTER_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.REMAX_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  // EzToTrack
  [`${EPlatformName.EZ_TO_TRACK}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.EZ_TO_TRACK}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  // EzToTrack resellers
  [`${EPlatformName.GOOD_DEAL_GPS}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.GOOD_DEAL_GPS}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.HOS_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.HOS_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.TRANSIT_TRACKING}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.TRANSIT_TRACKING}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.MT_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.MT_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.EAGLE_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.EAGLE_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.SMART_WAY_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.SMART_WAY_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.OXEMON}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.OXEMON}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.ROUTELINK_IO}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.ROUTELINK_IO}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.ELD4_TRUCKS}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.ELD4_TRUCKS}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.ATINA_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.ATINA_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.UNIFY_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.UNIFY_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.ELD_RUN}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.ELD_RUN}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.TERA_HUB}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.TERA_HUB}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.HOBBS_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.HOBBS_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.PINNACLE_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.PINNACLE_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.MEMENTO_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.MEMENTO_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.HORIZONT_PATH_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.HORIZONT_PATH_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.NOMAD_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.NOMAD_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.TXT_ELD}-${EAuthTypes.ACCOUNT}`]:
    BaseAccountNameWOInstructionsConfirmation,
  [`${EPlatformName.PAYD_ELD}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.PAYD_ELD}-${EAuthTypes.BASIC}`]: BaseUserPassword,
  [`${EPlatformName.HUTCH_SYSTEMS}-${EAuthTypes.TOKEN}`]: BaseToken,
  [`${EPlatformName.HUTCH_SYSTEMS}-${EAuthTypes.BASIC}`]: BaseUserPassword,
};
